export * from './image.entity';



// WEBPACK FOOTER //
// ./src/app/shared/entities/image/index.ts